import axiosClient from "./../apiClient.js";

const baseEndpoint = "/computer";

export const computerObject = {
  userName: "",
  id: 0,
  heading: "",
  contentTypeId: 0,
  contentType: "",
  content: "",
  photoAlignment: "",
  photoAlignmentId: 0,
  photoSize: "",
  photoSizeId: "",
  image: "",
};

export const getPreview = () => {
  return axiosClient.get(`${baseEndpoint}/getpreview`);
};

export const save = (data) => {
  return axiosClient.post(`${baseEndpoint}/save`, JSON.stringify(data));
};

export const update = (data) => {
  return axiosClient.post(`${baseEndpoint}/update`, JSON.stringify(data));
};

export const publish = (data) => {
  return axiosClient.post(`${baseEndpoint}/publish`, JSON.stringify(data));
};

export const deletePreview = (data) => {
  return axiosClient.post(
    `${baseEndpoint}/deletepreview`,
    JSON.stringify(data)
  );
};

export const deleteLive = (data) => {
  return axiosClient.post(`${baseEndpoint}/deletelive`, JSON.stringify(data));
};

export const getLive = () => {
  return axiosClient.get(`${baseEndpoint}/getlive`);
};

export const getLiveById = (id) => {
  return axiosClient.get(`${baseEndpoint}/getlivebyid?id=${id}`);
};
